import React from "react";
import close from "./close.svg";

const LLM = () => {
  function toggleWidget() {
    document.getElementById("collegeit-chat").style.display =
      document.getElementById("collegeit-chat").style.display === "block"
        ? "none"
        : "block";
    document.getElementById("collegeit-connect-expand").style.display =
      document.getElementById("collegeit-connect-expand").style.display ===
      "inline-block"
        ? "none"
        : "inline-block";
    document.getElementById("collegeit-connect-close").style.display =
      document.getElementById("collegeit-connect-close").style.display ===
      "block"
        ? "none"
        : "block";
  }

  return (
    <>
      <iframe
        style={{
          position: "fixed",
          top: "0px",
          right: "0px",
          width: "100%",
          margin: "0",
          padding: "0",
          overflow: "hidden",
          height: "100%",
        }}
        frameBorder={0}
        title="hey this is a dummy site"
        src="https://www.lls.edu/llm/"
      />
      <div
        id="collegeit-widget"
        style={{
          position: "fixed",
          bottom: "100px",
          right: "1vw",
        }}
      >
        <iframe
          id="collegeit-chat"
          sandbox="allow-scripts allow-popups allow-same-origin allow-forms allow-modals"
          style={{
            display: "none",
            opacity: 1,
            transform: "none",
            right: "1vw",
            boxShadow: "2px 2px 20px 2px rgba(0, 0, 0, 0.3)",
            minWidth: "360px",
            width: "25vw",
            minHeight: "70vh",
            height: "70vh",
            bottom: "-5vh",
            borderWidth: "0px",
            left: "auto",
            zIndex: "2147483000",
            position: "absolute",
            background: "white",
            transition: "250ms",
          }}
          src={"/widget"}
          title="the widget"
        />

        <button
          id="collegeit-connect-expand"
          style={{
            verticalAlign: "middle",
            display: "inline-block",
            position: "absolute",
            zIndex: "2147483003",
            bottom: "-15vh",
            right: "-3vw",
            width: "200px",
            backgroundColor: "transparent",
            border: 0,
            cursor: "pointer",
          }}
          onClick={toggleWidget}
        >
          <img height="90%" width="90%" src="/boston_button.png" alt="button" />
        </button>

        <button
          id="collegeit-connect-close"
          style={{
            backgroundColor: "transparent",
            border: "0",
            display: "none",
            position: "absolute",
            top: "-65vh",
            right: "1vw",
            zIndex: "2147483003",
            cursor: "pointer",
          }}
          onClick={toggleWidget}
        >
          <img src={close} alt="close" />
        </button>
      </div>
    </>
  );
};
export default LLM;
